<template>
  <div :class="d.boxClass">
    <!-- destroyOnClose 关闭时销毁 Dialog 中的元素 -->
    <!-- fullscreen 是否全屏 -->
    <!-- modal 是否需要遮罩层 -->
    <!-- modalAppendToBody  // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上 -->
    <!-- appendToBody   // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true -->
    <el-dialog
      :custom-class="d.class || 'paddingBottm'"
      :title="d.title || '提示'"
      :visible.sync="visible"
      :width="width || d.width || '900px'"
      :append-to-body="d.appendToBody || true"
      :modal="d.modal || true"
      :close-on-click-modal="false"
      class="DDialog"
      :fullscreen="d.fullscreen || false"
      :destroy-on-close="d.destroyOnClose || false"
      :modal-append-to-body="d.modalAppendToBody || true"
      :before-close="handleClose"
      @open="open('open')"
      @opened="open('opened')"
      @close="open('close')"
      @closed="open('closed')"
      :z-index="99999"
    >
      <span slot="title">
        <slot name="title">
          <i v-if="icon" :class="icon"></i>
          <span v-text="title"></span>
        </slot>
      </span>
      <slot />
      <span slot="footer">
        <slot name="footer" />
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * <DDialog :show.sync="show" :param="{width: '1400px',class:'xxxx'}" />
 */
import myMixin from './mixin.js';
export default {
  name: 'DDialog',
  mixins: [myMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val); // visible 改变的时候通知父组件
      },
    },
  },
  created() {
    var config = localStorage.getItem('theme');
    if (config) {
      config = JSON.parse(config);
      let color = config.dialog;
      document.documentElement.style.setProperty(
        'DDialog --el-dialog-header',
        color
      );
    }
  },
  methods: {
    /**
     * 模态窗方法
     */
    handleClose(done) {
      // 关闭前回调
      this.$emit('beforeClose');
      done();
    },
    open(key) {
      switch (key) {
        case 'open': // Dialog 打开的回调
          this.$emit('open');
          break;
        case 'opened': // Dialog 打开动画结束时的回调
          this.$emit('opened');
          break;
        case 'close': // Dialog 关闭的回调
          this.$emit('close');
          break;
        case 'closed': // Dialog 关闭动画结束时的回调
          this.$emit('closed');
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* ele弹窗样式 */
.DDialog {
  ::v-deep .el-dialog__wrapper {
    overflow-y: auto;
    overflow-x: hidden;
  }
  ::v-deep .padding .el-dialog__body {
    padding: 0px !important;
  }
  ::v-deep .paddingLeft .el-dialog__body {
    padding-left: 0px !important;
  }
  ::v-deep .paddingRight .el-dialog__body {
    padding-right: 0px !important;
  }
  ::v-deep .paddingTop .el-dialog__body {
    padding-top: 0px !important;
  }
  ::v-deep .paddingBottm .el-dialog__body {
    padding-bottom: 0px !important;
  }

  ::v-deep .el-dialog__header {
    padding: 0 20px;
    height: 45px;
    line-height: 45px;
    // background-color: #0570ff;
    border-bottom: 1px solid #ebf2f7;
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  ::v-deep .el-dialog__header > span > i {
    margin-right: 5px;
  }

  ::v-deep .el-dialog__title {
    // color: #fff;
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #999999;

    vertical-align: middle;
    // margin-top: -25px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 15px;
  }

  ::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
  ::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
    opacity: 0.8;
  }

  ::v-deep .dialog-footer {
    padding-right: 10px;
  }
  ::v-deep .el-icon-close:before {
    color: #333333 !important;
  }
}
::v-deep .el-dialog__wrapper {
  z-index: 9999999999999999 !important;
}
::v-deep .v-modal {
  z-index: 9999999999999999 !important;
}
</style>
